import { optional } from '@/helpers/dto2resource';
import { TaxasEJurosDto } from '../dto/DetalheOfertaDto';

class TaxasEJurosResource {
  taxaJurosMensalCet?: number;
  taxaJurosAnualCet?: number;
  taxaJurosMensal?: number;
  taxaJurosAnual?: number;
  valorIof?: number;
  descricaoIof?: string;
  valorJurosParcelamento?: number;

  constructor(dto: TaxasEJurosDto) {
    this.taxaJurosMensalCet = optional(dto.taxaJurosMensalCet);
    this.taxaJurosAnualCet = optional(dto.taxaJurosAnualCet);
    this.taxaJurosMensal = optional(dto.taxaJurosMensal);
    this.taxaJurosAnual = optional(dto.taxaJurosAnual);
    this.valorIof = optional(dto.valorIof);
    this.descricaoIof = optional(dto.descricaoIof);
    this.valorJurosParcelamento = optional(dto.valorJurosParcelamento);
  }
}

export default TaxasEJurosResource;
